import React from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';

const cardStyle = { fontWeight: 300, display: 'inline-block' };
export const Page = ({
  title,
  children,
  filterType,
  filterValue,
  filterTypeName,
  card = true,
  cardBodyClassName,
  ...props
}) =>
  card ? (
    <Card className="mt-2" {...props}>
      <CardBody className={cardBodyClassName}>
        {title && <CardTitle style={cardStyle}>{title}</CardTitle>}
        <div className="mt-1">{children}</div>
      </CardBody>
    </Card>
  ) : (
    <div className="mt-2" {...props}>
      <div>
        <CardTitle style={cardStyle}>{title}</CardTitle>
        <div className="mt-1">{children}</div>
      </div>
    </div>
  );

export default Page;



// WEBPACK FOOTER //
// ./src/components/common/Page.jsx